// Constants for evaluation dashboard

export const COLOR_THEMES = {
  blue: {
    border: 'border-blue-500/40',
    bg: 'bg-blue-900/20',
    text: 'text-blue-100',
    headerHover: 'hover:bg-blue-500/10',
    focusRing: 'focus:ring-blue-500',
  },
  amber: {
    border: 'border-amber-500/40',
    bg: 'bg-amber-900/20',
    text: 'text-amber-100',
    headerHover: 'hover:bg-amber-500/10',
    focusRing: 'focus:ring-amber-500',
  },
  red: {
    border: 'border-red-500/40',
    bg: 'bg-red-900/20',
    text: 'text-red-200',
    headerHover: 'hover:bg-red-500/10',
    focusRing: 'focus:ring-red-500',
  },
  green: {
    border: 'border-green-500/40',
    bg: 'bg-green-900/20',
    text: 'text-green-100',
    headerHover: 'hover:bg-green-500/10',
    focusRing: 'focus:ring-green-500',
  },
  gray: {
    border: 'border-gray-500/40',
    bg: 'bg-gray-800/50',
    text: 'text-gray-200',
    headerHover: 'hover:bg-gray-700/50',
    focusRing: 'focus:ring-gray-500',
  },
};

export const SECTION_KEYS = {
  COACH: {
    HISTORY: 'history',
    SUMMARIES: 'summaries',
    LTM: 'ltm',
  },
  JUDGE: {
    HISTORY: 'judge_history',
    LTM: 'judge_ltm',
  },
};

export const PREVIEW_LENGTHS = {
  DEFAULT: 150,
  SHORT: 100,
  REASONING: 80,
};

export const COPY_BUTTON_CLASSES = {
  BASE: 'absolute top-2 right-10 p-1.5 text-gray-300 hover:text-white hover:bg-gray-800/50 rounded transition-colors z-10',
  FOCUS: 'focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:ring-offset-gray-900',
};

export const SPACING = {
  SECTION_GAP: 'space-y-3',
  ITEM_GAP: 'gap-2',
  LARGE_GAP: 'gap-3',
};

